import React, { useEffect, useState } from "react";

import { addToQueue } from "../../../service/utils";
import PlaylistService from "../../../service/playlist-service";
import View from "./view";
import Loading from "../../views/loading";
import Error from "../../views/error";

const STATUS = { LOADING: 1, ERROR: 2, SUCCESS: 3 };

export default ({ match }) => {
  const [status, setStatus] = useState(STATUS.LOADING);
  const [playlist, setPlaylist] = useState("");
  const [savedSongs, setSavedSongs] = useState("");

  const fetchSavedSongs = async () => {
    const s = await PlaylistService.saved();
    if (s) setSavedSongs(s);
  };
  const fetchPlaylist = async () => {
    const p = await PlaylistService.getPlaylist({
      id: match.params.id,
    });
    if (p) {
      setPlaylist(p);
      setStatus(STATUS.SUCCESS);
    } else {
      setStatus(STATUS.ERROR);
    }
  };

  useEffect(() => {
    fetchPlaylist();
  }, [match.params.id]);

  useEffect(() => {
    fetchSavedSongs();
  }, []);

  switch (status) {
    case STATUS.LOADING:
      return <Loading />;
    case STATUS.SUCCESS:
      return (
        <View
          playlist={playlist}
          savedSongs={savedSongs}
          refresh={() => {
            // can be optimized
            fetchPlaylist();
            fetchSavedSongs();
          }}
        />
      );
    case STATUS.ERROR:
      return <Error message="Invalid playlist id" />;
    default:
      return <Error message="Invalid playlist id" />;
  }
};
